import api from "@/lib/axios";

interface FeedbackRequest {
  type: 'bug' | 'feature' | 'improvement' | 'question' | 'other';
  message: string;
}

interface FeedbackResponse {
  success: boolean;
  message?: string;
  error?: string;
}

export async function submitFeedback(feedback: FeedbackRequest): Promise<FeedbackResponse> {
  try {
    const response = await api.post("/feedback", feedback);
    return response.data;
  } catch (error: unknown) {
    console.error("Failed to submit feedback:", error);
    const axiosError = error as { response?: { data?: { error?: string } } };
    return {
      success: false,
      error: axiosError.response?.data?.error || "Failed to submit feedback. Please try again.",
    };
  }
}

// Crawl-specific feedback
interface CrawlFeedbackRequest {
  jobId: string;
  rating: 'positive' | 'negative';
  comment?: string;
}

export async function submitCrawlFeedback(feedback: CrawlFeedbackRequest): Promise<FeedbackResponse> {
  try {
    const response = await api.post("/feedback/crawl", feedback);
    return response.data;
  } catch (error: unknown) {
    console.error("Failed to submit crawl feedback:", error);
    const axiosError = error as { response?: { data?: { error?: string } } };
    return {
      success: false,
      error: axiosError.response?.data?.error || "Failed to submit feedback. Please try again.",
    };
  }
}
